module.exports = __webpack_public_path__ + "img/full5-min.e591ab1a.png";